
import { mapState } from 'vuex';

export default {
  name: 'AppRatingInput',
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      hoverValue: 0,
      supportsHover: window.matchMedia('(hover: hover)').matches
    };
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings'])
  },
  methods: {
    onMouseEnter(value) {
      if (this.supportsHover) this.hoverValue = value;
    },
    onMouseLeave() {
      if (this.supportsHover) this.hoverValue = 0;
    }
  }
};
